// extracted by mini-css-extract-plugin
export var quantityInput = "_mt-0";